import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './plugins/flatpickr/flatpickr.min.css';
import flatpickr from './plugins/flatpickr/esm/index.js';
import { Spanish } from './plugins/flatpickr/esm/l10n/es.js';

window.flatpickr = flatpickr;

const dayMs = 24 * 60 * 60 * 1000;

const formatYmd = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const updateTripRangeFields = (input, selectedDates) => {
    const form = input.closest('form');
    if (!form) {
        return;
    }

    const fromInput = form.querySelector('[data-cms-hero-date-from]');
    const toInput = form.querySelector('[data-cms-hero-date-to]');
    const daysInput = form.querySelector('[data-cms-hero-trip-days]');
    const startDate = selectedDates[0] instanceof Date ? selectedDates[0] : null;
    const endDate = selectedDates[1] instanceof Date ? selectedDates[1] : null;

    if (fromInput) {
        fromInput.value = startDate ? formatYmd(startDate) : '';
    }

    if (toInput) {
        toInput.value = endDate ? formatYmd(endDate) : '';
    }

    if (daysInput) {
        daysInput.value = startDate && endDate
            ? String(Math.max(1, Math.round((endDate - startDate) / dayMs) + 1))
            : '';
    }
};

const initHeroDateRanges = (root = document) => {
    if (typeof flatpickr !== 'function') {
        return;
    }

    root.querySelectorAll('[data-cms-hero-date-range]:not([data-cms-hero-date-ready])').forEach((input) => {
        input.setAttribute('data-cms-hero-date-ready', '1');

        flatpickr(input, {
            mode: 'range',
            minDate: 'today',
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd/m/Y',
            locale: {
                ...Spanish,
                rangeSeparator: ' hasta ',
            },
            onChange: (selectedDates) => updateTripRangeFields(input, selectedDates),
            onClose: (selectedDates) => updateTripRangeFields(input, selectedDates),
            onReady: (selectedDates, dateStr, instance) => {
                instance.calendarContainer.classList.add('cms-hero-flatpickr');
            },
        });
    });
};

const initHeroInterestSelects = (root = document) => {
    root.querySelectorAll('.js-hero-interests-select:not([data-cms-hero-interests-ready])').forEach((select) => {
        select.setAttribute('data-cms-hero-interests-ready', '1');
        select.classList.add('cms-hero-native-select');

        const options = Array.from(select.options).filter((option) => option.value !== '' && !option.disabled);
        const placeholder = select.getAttribute('data-placeholder') || 'Intereses';
        const wrapper = document.createElement('div');
        const control = document.createElement('button');
        const tags = document.createElement('span');
        const arrow = document.createElement('span');
        const menu = document.createElement('ul');

        wrapper.className = 'cms-hero-multiselect';
        control.type = 'button';
        control.className = 'cms-hero-multiselect-control';
        control.setAttribute('aria-expanded', 'false');
        tags.className = 'cms-hero-multiselect-tags';
        arrow.className = 'cms-hero-multiselect-arrow';
        menu.className = 'cms-hero-multiselect-menu';

        control.append(tags, arrow);
        wrapper.append(control, menu);
        select.insertAdjacentElement('afterend', wrapper);

        const close = () => {
            wrapper.classList.remove('is-open');
            control.setAttribute('aria-expanded', 'false');
        };

        const open = () => {
            wrapper.classList.add('is-open');
            control.setAttribute('aria-expanded', 'true');
        };

        const renderTags = () => {
            tags.innerHTML = '';
            const selectedOptions = options.filter((option) => option.selected);

            if (selectedOptions.length === 0) {
                const placeholderElement = document.createElement('span');
                placeholderElement.className = 'cms-hero-multiselect-placeholder';
                placeholderElement.textContent = placeholder;
                tags.appendChild(placeholderElement);

                return;
            }

            selectedOptions.forEach((option) => {
                const tag = document.createElement('span');
                const label = document.createElement('span');
                const remove = document.createElement('button');

                tag.className = 'cms-hero-multiselect-tag';
                label.textContent = option.textContent.trim();
                remove.type = 'button';
                remove.className = 'cms-hero-multiselect-remove';
                remove.setAttribute('aria-label', `Quitar ${option.textContent.trim()}`);
                remove.textContent = 'x';
                remove.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    option.selected = false;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    render();
                });

                tag.append(label, remove);
                tags.appendChild(tag);
            });
        };

        const renderMenu = () => {
            menu.innerHTML = '';

            options.forEach((option) => {
                const item = document.createElement('li');
                const button = document.createElement('button');

                button.type = 'button';
                button.className = `cms-hero-multiselect-option${option.selected ? ' is-selected' : ''}`;
                button.textContent = option.textContent.trim();
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    option.selected = !option.selected;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    render();
                    open();
                });

                item.appendChild(button);
                menu.appendChild(item);
            });
        };

        const render = () => {
            renderTags();
            renderMenu();
        };

        control.addEventListener('click', (event) => {
            event.preventDefault();
            wrapper.classList.contains('is-open') ? close() : open();
        });

        control.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                close();
            }
        });

        document.addEventListener('click', (event) => {
            if (!wrapper.contains(event.target)) {
                close();
            }
        });

        render();
    });
};

const initFrontHeroSearch = () => {
    initHeroDateRanges();
    initHeroInterestSelects();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFrontHeroSearch, { once: true });
} else {
    initFrontHeroSearch();
}
